import Vue from 'vue'

const numbro = require('numbro')

Vue.prototype.$numbro = numbro?.default || numbro
